import Prismic from 'prismic-javascript';
import { ERROR } from 'translations';

import { GLOBAL_ERROR } from '../../actions/errors';
import { API_CLIENT_CONFIG, API_ENDPOINT } from './prismic-config';

/**
 * Helper function to return a Global Error when an error occured during Master Ref fetching
 *
 * @param {Object} err
 */
const newGlobalError = (err) => ({
  name: GLOBAL_ERROR,
  status: 'Oops',
  payload: err,
  message: ERROR.ERROR_FETCHING_BACKEND,
});

let prismicConfig = API_CLIENT_CONFIG;

export const setPrismicConfig = (config) => {
  prismicConfig = {
    ...API_CLIENT_CONFIG,
    ...config,
  };
};

/**
 * A helper function to initialize a Prismic API Client
 *
 * @return {Promise}
 */
export default () =>
  Prismic.getApi(API_ENDPOINT, prismicConfig).catch((err) => {
    // eslint-disable-next-line
    console.log(err);
    throw newGlobalError(err);
  });
